export const domains = [
    'vivosun.shop',
    'vivosun.store',
    'vivosunca.com',
    'vivosunshop.shop',
    'vivosungrowtent.com',
    'encyclopediaxx.shop',
    'wllitediscountsclub.com',
    'vivosunus.shop',
    'vivosungrow.shop',
    'vivosunus.com',
    'vivosunshopus.com',
];